module.exports = __webpack_public_path__ + "img/tool-doc.a26be052.svg";